import { registerNamespace } from '@/shared/i18n'

import en from './en.json'
import ru from './ru.json'

/**
 * Imported for its side effect by the feature's pages. Only flow-specific copy
 * lives here — `common.auth.*` and `common.actions.*` already carry the shared
 * labels and stay where they are.
 */
registerNamespace('auth', { en, ru })

// A namespace is registered by a side effect, and Vite does not re-run a module
// just because a JSON file it imports changed — so editing a translation left
// the old bundle in memory and the raw key on screen until a full reload.
// Self-accepting re-runs `registerNamespace`, which overwrites the bundle.
if (import.meta.hot) import.meta.hot.accept()
